/** @module csi/table/ToolbarFilmStripFind */
define([
	"csi/html",
	"csi/view/PluginFactory",
	"csi/view/ToolbarFind",
	"dojo/text!csi/table/ToolbarFilmStripFind.html",

	"dijit/form/Button",
	"dijit/form/TextBox"
], function(html, PluginFactory, ToolbarFind, template) {

	const MODE_FULL = 0; // Table view
	const MODE_SEARCH_BTN = 1; // Film Strip view, search plugin is closed
	const MODE_SEARCHING = 2; // Film Strip view, search plugin is opened

	return PluginFactory.declare("FilmStripFind", ToolbarFind, {
		templateString: template,

		/**
		 * @override
		 * Update display of plugin based on view properties
		 */
		canShowPlugin: function() {
			var view = this.getView();
			if (view.inFilmstripMode()) {
				if (view.get("showFilmstripSearch")) {
					this._toggleSearchMode(MODE_SEARCHING);
				} else {
					this._toggleSearchMode(MODE_SEARCH_BTN);
				}
			} else {
				this._toggleSearchMode(MODE_FULL);
			}
			return true;
		},

		/**
		 * @override
		 * Set initial value
		 */
		startup: function() {
			const view = this.getView();
			const text = view.get("filmstripSearchText");

			this.set("value", text, false);

			view.watch("filmstripSearchText", this._onWatchSearchText.bind(this));

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Find is always valid in Filmstrip case and does not require findAttributes as in ToolbarFind
		 */
		validatePlugin: function(ctx) {
			return true;
		},

		/**
		 * Callback when user click on "Open Search" button in film strip mode
		 * @param {Event} ev
		 */
		_onSearchOpenClick: function(ev) {
			this.getView().set("showFilmstripSearch", true);
			this.textNode.focus();
		},

		/**
		 * Callback when user click on "Close Search" button
		 * @param {Event} ev
		 */
		_onSearchCloseClick: function(ev) {
			this.getView().set("showFilmstripSearch", false);
			this.set("value", "");
		},

		/**
		 * Update widget value to new value
		 * @param {string} name
		 * @param {string} oldValue
		 * @param {string} newValue
		 */
		_onWatchSearchText: function(name, oldValue, newValue) {
			this.set("value", newValue, false);
		},

		/**
		 * Add title attribute to input field
		 */
		_setTitleAttr: {node: "innerNode", type: "attribute"},

		/**
		 * Set visibility of plugin component depend on the state value
		 * @param {Number} state
		 */
		_toggleSearchMode: function(state) {
			html.setVisible(this.btnSearchCloseNode, state == MODE_SEARCHING);
			html.setVisible(this.btnSearchNode, state == MODE_SEARCH_BTN);
			html.setVisible(this.innerNode, (state == MODE_FULL) || (state == MODE_SEARCHING));
		}
	});
});